import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  private authenticationHeader = { headers: { authentication: '', mode: environment.mode } };

  constructor() {
  }

  /* * rest api * */
  private static handleAPIError(err: Error) {
    throw err;
  }

  public find(endpoint: string, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, null, params)).then(result => {
      return result;
    }).catch(err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public get(endpoint: string, id?: string, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, id, params)).then(result => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public getSimple(path): Promise<any> {
    return this.request(path, 'GET', null, true).then(result => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public post(endpoint: string, data: any): Promise<any> {
    return this.request(this.getPath(endpoint), 'POST', data).then((result: any) => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public create(endpoint: string, data: any, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, null, params), 'POST', data).then((result: any) => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public update(endpoint: string, id: string, data: any, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, id, params), 'PUT', data).then((result: any) => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public patch(endpoint: string, id: string, data: any, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, id, params), 'PATCH', data).then((result: any) => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public remove(endpoint: string, id: string, params?: any): Promise<any> {
    return this.request(this.getPath(endpoint, id, params), 'DELETE').then((result: any) => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  public getHotelInfo(id: string): Promise<any> {
    return this.request('https://hotels.ibexfusion.com/detail?id=' + id).then(result => {
      return result;
    }, err => {
      return ConnectionService.handleAPIError(err);
    });
  }

  /* * helpers  * */
  public setAuthenticationHeader(session: any) {
    if (session && session.sessionId) {
      this.authenticationHeader.headers.authentication = session.sessionId + ':' + session.secret;
    } else {
      console.log('getAuthenticationHeader: no sessionId available yet !!!');
    }
  }

  private request(url, type = 'GET', data?, noHeaders = false): Promise<any> {
    data = data && typeof data !== 'string' ? JSON.stringify(data) : data;
    return new Promise((resolve, reject) => {
      const requestTimeout = setTimeout(() => {
        reject('request for url: ' + url + ' timed out');
      }, 5000);
      try {
        const http = new XMLHttpRequest();
        http.onreadystatechange = () => {
          if (http.readyState === 4) {
            clearTimeout(requestTimeout);
            if (http.status >= 200 && http.status <= 400) {
              let result = http.responseText;
              try {
                result = JSON.parse(http.responseText);
              } catch (err) {
                console.warn('could not parse request result for url: ' + url);
              }
              resolve(result);
            } else {
              reject(http);
            }
          }
        };
        http.open(type, url, true);
        if (!noHeaders) {
          let headers = JSON.parse(JSON.stringify(this.authenticationHeader));
          headers = !!headers.headers ? headers.headers : headers;
          for (const key of Object.keys(headers)) {
            http.setRequestHeader(key, headers[key]);
          }
        }
        if (data) {
          http.setRequestHeader('Content-Type', 'application/json');
        }
        http.send(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  private getPath(endpoint: string, id?: string, params?: any) {
    let path = endpoint;
    if (!path.startsWith('http')) {
      path = environment.backendUrl + (endpoint.startsWith('/') ? endpoint : '/' + endpoint);
    }
    if (id) {
      path += '/' + id;
    }
    if (params) {
      path += this.prepareParams(params);
    }
    return path;
  }

  private prepareParams(params: any) {
    if (!params) {
      return '';
    }
    return '?' + this.urlEncode(params);
  }

  private urlEncode(srcjson: any, parent = '') {
    if (typeof srcjson !== 'object') {
      if (typeof console !== 'undefined') {
        console.log('\"srcjson\" is not a JSON object');
        return null;
      }
    }

    const u = encodeURIComponent;
    let urljson = '';
    const keys = Object.keys(srcjson);

    for (let i = 0; i < keys.length; i++) {
      const k = parent ? parent + '[' + keys[i] + ']' : keys[i];

      if (typeof srcjson[keys[i]] !== 'object') {
        urljson += u(k) + '=' + u(srcjson[keys[i]]);
      } else {
        urljson += this.urlEncode(srcjson[keys[i]], k);
      }
      if (i < (keys.length - 1)) {
        urljson += '&';
      }
    }

    return urljson;
  }

}
